import { render, staticRenderFns } from "./SysTypeTreeManager.vue?vue&type=template&id=baecd980&scoped=true&"
import script from "./SysTypeTreeManager.vue?vue&type=script&lang=js&"
export * from "./SysTypeTreeManager.vue?vue&type=script&lang=js&"
import style0 from "./SysTypeTreeManager.vue?vue&type=style&index=0&id=baecd980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baecd980",
  null
  
)

export default component.exports